
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import DetailDrinksScreens from './detailDrinks'

function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [type, setType] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);



    
          useEffect(() => {
                menus.map((item) => {
                    if (item.id === 479) {
                        setdrinks(item);
                    }
                });
          }, [menus]);
        
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={() => {
            setShowSpecials(true)
        }}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>
                    <div
                    style={{
                        paddingHorizontal: 20,

                        flex: 1,
                    }}>
                    <div
                        style={{
                        width: '100%',
                                marginTop: 50,
                        position: 'relative',
                        }}>
                        <img
                        src={require('./assets/image1.png')}
                        style={{
                            top: 0,
                            left: 0,
                            width: 200,
                            height: 300,
                            objectFit: 'contain',
                            borderRadius: 40,
                            position: 'absolute',
                            zIndex: 999,
                        }}
                        />
                        <p
                        style={{
                            fontSize: 35,
                            color: 'white',
                            textAlign: 'center',
                            textTransform: 'uppercase',
                            fontWeight: 'bold',
                        }}>
                         SANDWICH
                            </p>
                            <p
                            style={{
                                fontSize: 15,
                                color: '#EBB234',
                                textAlign: 'center',
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                            }}>
                            ADD FRENCH FRIES $2.75
                            </p>
                        <img
                        src={require('./assets/image2.png')}
                        style={{
                            top: 20,
                            right: 0,
                            width: 200,
                            height: 300,
                            objectFit: 'contain',
                            borderRadius: 40,
                            alignSelf: 'center',
                            position: 'absolute',
                            zIndex: 999,
                        }}
                        />
                    </div>
                    <video
                        src={require('./assets/sandwich.mp4')}
                        
                            loop
                            autoPlay
                            muted
                        style={{
                        marginTop: 20,
                        width: 500,
                        height: 210,
                        borderRadius: 14,
                            alignSelf: 'center',
                        objectFit: "cover"
                        }}
                    />
                    <div style={{overflow: 'scroll'}}>
                      
                        <img
                            src={
                            langEng
                                ? require('./assets/textsan.png')
                                : require('./assets/textsan.png')
                            }
                            style={{
                            width: '70%',
                             height: 370,
                            objectFit: 'contain',

                            alignSelf: 'center',
                            position: 'relative',
                            zIndex: 1,
                            }}
                        />

                       
                            <img
                            src={require('./assets/ashfdgjd.png')}
                            style={{
                                width: '75%',
                                height: 120,
                                objectFit: 'cover',
                                borderRadius: 20,
                                alignSelf: 'center',
                                position: 'relative',
                                zIndex: 1,
                            }}
                            />
                      

                      

                    </div>
                    </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                 {showDrinks && <DetailDrinksScreens setshowCategories={setShowDrinks} type={type} goBack={setShowDrinks}  goHome={setshowCategories} />}
            </LayoutContent>
        </div>
    );
}
export default Index;